<template>
	<div>
		<page-authorization-container :page="page" require-admin>
			<h2 class="mb-4">Create a new weather dataset</h2>
			<p>Files must be placed on the server.</p>

			<admin-weather-form :data="data"></admin-weather-form>
		</page-authorization-container>
	</div>
</template>

<script>
	import AdminWeatherForm from '@/views/admin/datasets/weather/AdminWeatherForm';

	export default {
		name: 'AdminWeatherCreate',
		components: {
			AdminWeatherForm
		},
		data() {
			return {
				page: {
					errors: [],
					loading: false,
					showLogin: false
				},
				data: {}
			}
		}
	}
</script>
